const ConfigRoutes = [
  // 配置模型管理
  {
    path: 'config-model',
    name: 'ConfigModel',
    redirect: '/manage/system/config-model/list',
    component: () => import(/* webpackChunkName: "ConfigModel" */ '@/views/content'),
    meta: {
      sidebar: 2,
      authKey: ['auth_dict'],
      title: 'com_sider_menu_config',
      disabled: false,
      icon: 'menu_config_model',
    },
    children: [
      {
        path: 'list',
        name: 'ConfigModelList',
        component: () =>
          import(/* webpackChunkName: "ConfigModelList" */ '@/views/system/configModel'),
        meta: {
          breadcrumb: false,
          sidebar: true,
          authKey: ['auth_dict'],
          title: 'com_sider_menu_config_list',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
      {
        path: 'group',
        name: 'ConfigModelGroup',
        component: () =>
          import(
            /* webpackChunkName: "ConfigModel" */ '@/views/system/configModel/group/index.vue'
          ),
        meta: {
          sidebar: false,
          authKey: ['auth_dict_group'],
          title: 'com_sider_menu_config_group',
          disabled: false,
          icon: null,
          autoCollect: false,
        },
      },
    ],
  },
];

export default ConfigRoutes;
